import { render, staticRenderFns } from "./PermissionRecordVersions.vue?vue&type=template&id=89b5c8e8"
import script from "./PermissionRecordVersions.vue?vue&type=script&lang=js"
export * from "./PermissionRecordVersions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports